import { Chip } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
const colorMap = {
    primary: {
        backgroundColor: themeColors.accent.blue.subtlest,
        color: themeColors.accent.blue.bold,
        ['.MuiChip-deleteIcon']: {
            color: themeColors.accent.blue.bold,
        },
        '&:hover': {
            '& .MuiChip-deleteIcon': {
                color: themeColors.accent.blue.bold,
            },
        },
    },
    warning: {
        backgroundColor: themeColors.accent.orange.subtlest,
        color: themeColors.accent.orange.bold,
        ['.MuiChip-deleteIcon']: {
            color: themeColors.accent.orange.bold,
        },
        '&:hover': {
            '& .MuiChip-deleteIcon': {
                color: themeColors.accent.orange.bold,
            },
        },
    },
    error: {
        backgroundColor: themeColors.accent.red.subtlest,
        color: themeColors.accent.red.bold,
        ['.MuiChip-deleteIcon']: {
            color: themeColors.accent.red.bold,
        },
        '&:hover': {
            '& .MuiChip-deleteIcon': {
                color: themeColors.accent.red.bold,
            },
        },
    },
    success: {
        backgroundColor: themeColors.accent.green.subtlest,
        color: themeColors.accent.green.bold,
        ['.MuiChip-deleteIcon']: {
            color: themeColors.accent.green.bold,
        },
        '&:hover': {
            '& .MuiChip-deleteIcon': {
                color: themeColors.accent.green.bold,
            },
        },
    },
    default: {
        backgroundColor: themeColors.accent.grey.subtlest,
        color: themeColors.accent.grey.bold,
        ['.MuiChip-deleteIcon']: {
            color: themeColors.accent.grey.bold,
        },
        '&:hover': {
            '& .MuiChip-deleteIcon': {
                color: themeColors.accent.grey.bold,
            },
        },
    },
};
export const ChipLight = (props) => {
    return (React.createElement(Chip, Object.assign({}, props, { sx: Object.assign(Object.assign({}, colorMap[props.color || 'primary']), props.sx), "data-test": `${props.color || 'primary'}-chip` })));
};
